export enum ProjectPaymentType {
  FLAT_FEE = 'Flat fee',
  HOURLY_RATE = 'Hourly rate'
}
